import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom-v5-compat";
import { ListItem, url } from "lcm-iot-commons";
import { administrationShape } from "../../shapes/administrationsShape";

type OwnProps = {
  administration?: administrationShape;
};

const defaultProps: Partial<OwnProps> = {
  administration: undefined,
};

type Props = OwnProps & typeof defaultProps;

export default function AdministrationItem({ administration }: Props) {
  const navigate = useNavigate();
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const iconClassname = `lcm-iot-icon-${administration.type}`;
  // @ts-expect-error TS(2339) FIXME: Property 'titleId' does not exist on type 'adminis... Remove this comment to see the full error message
  const { titleId, descriptionId, href, external } = administration;

  const handleOnClick = () => {
    if (external) {
      window.location.href = href;
    } else {
      navigate(url(href));
    }
  };

  return (
    <ListItem
      onClick={handleOnClick}
      id={`administration-item-${titleId}`}
      title={<FormattedMessage id={titleId} />}
      description={<FormattedMessage id={descriptionId} />}
      icon={iconClassname}
    />
  );
}

AdministrationItem.defaultProps = defaultProps;
